export default [
  {
    id: 'Indicator 1.1. Access and Admission',
    title: 'Standard 1: Access, Transfer, and Progression',
    submissionDate: '2024-01-15',
    status: 'approved',
    notes: 'All required documentation included',
    comments: 'Excellent presentation of data',
    reviewer: 'Maria Rodriguez'
  },
  {
    id: 'Indicator 1.2. Credit Accumulation',
    title: 'Standard 1: Access, Transfer, and Progression',
    submissionDate: '2024-01-20',
    status: 'in-review',
    notes: 'Awaiting review',
    comments: 'Under evaluation',
    reviewer: 'James Wilson'
  },
  {
    id: 'Indicator 1.3. Internal and External Credit Transfer',
    title: 'Standard 1: Access, Transfer, and Progression',
    submissionDate: '2024-01-25',
    status: 'in-review',
    notes: 'Documentation pending',
    comments: 'Please review transfer policies',
    reviewer: 'Alex Thompson'
  },
  {
    id: 'Indicator 1.4. Career Progression and Learning Pathways',
    title: 'Standard 1: Access, Transfer, and Progression',
    submissionDate: '2024-01-28',
    status: 'in-review',
    notes: 'Pathway documentation attached',
    comments: 'Review in progress',
    reviewer: 'Susan Chen'
  },
  {
    id: 'Indicator 1.5. Recognition of Prior Learning (RPL)',
    title: 'Standard 1: Access, Transfer, and Progression',
    submissionDate: '2024-02-01',
    status: 'approved',
    notes: 'RPL procedures verified',
    comments: 'Meets requirements',
    reviewer: 'Daniel Park'
  },
  {
    id: 'Indicator 1.6. Appeal Against Access and Transfer',
    title: 'Standard 1: Access, Transfer, and Progression',
    submissionDate: '2024-02-05',
    status: 'in-review',
    notes: 'Appeal process documentation',
    comments: 'Under review',
    reviewer: 'Rachel Kim'
  },
  {
    id: 'Indicator 2.1. Justification of Need',
    title: 'Standard 2: Qualification Development, Approval and Review',
    submissionDate: '2024-02-10',
    status: 'in-review',
    notes: 'Needs analysis included',
    comments: 'Pending approval',
    reviewer: 'Michael Chang'
  },
  {
    id: 'Indicator 2.2. Qualification Design',
    title: 'Standard 2: Qualification Development, Approval and Review',
    submissionDate: '2024-02-15',
    status: 'approved',
    notes: 'Design documentation complete',
    comments: 'Meets standards',
    reviewer: 'Emma Davis'
  },
  {
    id: 'Indicator 2.3. Qualification Compliance',
    title: 'Standard 2: Qualification Development, Approval and Review',
    submissionDate: '2024-02-20',
    status: 'in-review',
    notes: 'Compliance documentation attached',
    comments: 'Under compliance review',
    reviewer: 'Christopher Lee'
  },
  {
    id: 'Indicator 2.4. Learning Resources and Learners Support',
    title: 'Standard 2: Qualification Development, Approval and Review',
    submissionDate: '2024-02-25',
    status: 'in-review',
    notes: 'Resource documentation attached',
    comments: 'Review of support systems ongoing',
    reviewer: 'Nicole Martinez'
  },
  {
    id: 'Indicator 2.5. Qualification Internal Approval',
    title: 'Standard 2: Qualification Development, Approval and Review',
    submissionDate: '2024-03-01',
    status: 'approved',
    notes: 'Internal approval documentation complete',
    comments: 'Meets internal standards',
    reviewer: 'Sarah Johnson'
  },
  {
    id: 'Indicator 2.6. Qualification Internal and External Evaluation and Review',
    title: 'Standard 2: Qualification Development, Approval and Review',
    submissionDate: '2024-03-05',
    status: 'in-review',
    notes: 'Evaluation reports attached',
    comments: 'External review pending',
    reviewer: 'David Brown'
  },
  {
    id: 'Indicator 3.1. Assessment Design',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-03-10',
    status: 'approved',
    notes: 'Assessment design documentation complete',
    comments: 'Approved by assessment committee',
    reviewer: 'Lisa Wang'
  },
  {
    id: 'Indicator 3.2. Internal and External Verification and Moderation of Assessment',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-03-15',
    status: 'in-review',
    notes: 'Verification processes attached',
    comments: 'External moderation ongoing',
    reviewer: 'Robert Taylor'
  },
  {
    id: 'Indicator 3.3. Marking Criteria',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-03-20',
    status: 'approved',
    notes: 'Marking schemes attached',
    comments: 'Criteria approved',
    reviewer: 'Jennifer Adams'
  },
  {
    id: 'Indicator 3.4. Measuring the Achievement of Learning Outcomes',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-03-25',
    status: 'in-review',
    notes: 'Measurement tools attached',
    comments: 'Review of outcomes ongoing',
    reviewer: 'Kevin Wilson'
  },
  {
    id: 'Indicator 3.5. Feedback to Learners',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-03-30',
    status: 'approved',
    notes: 'Feedback mechanisms documented',
    comments: 'Systems in place',
    reviewer: 'Michelle Lee'
  },
  {
    id: 'Indicator 3.6. Approval of Assessment Results',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-04-05',
    status: 'in-review',
    notes: 'Approval procedures attached',
    comments: 'Final review pending',
    reviewer: 'Thomas Anderson'
  },
  {
    id: 'Indicator 3.7. Appeal Against Assessment Results',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-04-10',
    status: 'approved',
    notes: 'Appeal procedures documented',
    comments: 'Systems verified',
    reviewer: 'Patricia White'
  },
  {
    id: 'Indicator 3.8. Integrity of Assessment',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-04-15',
    status: 'in-review',
    notes: 'Integrity measures documented',
    comments: 'Review in progress',
    reviewer: 'Richard Miller'
  },
  {
    id: 'Indicator 3.9. Security of Assessment Documents and Records',
    title: 'Standard 3: Assessment Design and Moderation',
    submissionDate: '2024-04-20',
    status: 'approved',
    notes: 'Security protocols documented',
    comments: 'Standards met',
    reviewer: 'Laura Garcia'
  },
  {
    id: 'Indicator 4.1. Certificate Issuance',
    title: 'Standard 4: Certification',
    submissionDate: '2024-04-25',
    status: 'in-review',
    notes: 'Issuance procedures attached',
    comments: 'Review ongoing',
    reviewer: 'Andrew Wilson'
  },
  {
    id: 'Indicator 4.2. Certificate Authentication',
    title: 'Standard 4: Certification',
    submissionDate: '2024-04-30',
    status: 'approved',
    notes: 'Authentication processes verified',
    comments: 'Meets requirements',
    reviewer: 'Elizabeth Chen'
  },
  {
    id: 'Indicator 4.3. Records of Certification',
    title: 'Standard 4: Certification',
    submissionDate: '2024-05-05',
    status: 'in-review',
    notes: 'Record keeping procedures attached',
    comments: 'Final review pending',
    reviewer: 'William Taylor'
  },
  {
    id: 'Indicator 5.1. Institution Quality Assurance System',
    title: 'Standard 5: Sustainability and Continuous Quality Improvement',
    submissionDate: '2024-05-10',
    status: 'approved',
    notes: 'QA system documentation complete',
    comments: 'System verified',
    reviewer: 'Helen Brown'
  },
  {
    id: 'Indicator 5.2. Continuous Improvement of Institution Quality Assurance System',
    title: 'Standard 5: Sustainability and Continuous Quality Improvement',
    submissionDate: '2024-05-15',
    status: 'in-review',
    notes: 'Improvement procedures attached',
    comments: 'Review in progress',
    reviewer: 'George Martinez'
  },
  {
    id: 'Indicator 5.3. Risk and Crisis Management',
    title: 'Standard 5: Sustainability and Continuous Quality Improvement',
    submissionDate: '2024-05-20',
    status: 'approved',
    notes: 'Risk management procedures verified',
    comments: 'Protocols approved',
    reviewer: 'Sandra Lee'
  }
];